import React, { useEffect, useState } from "react";
import { getAccessToken, clearLocalStorage } from "../../authService";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../api/user";

const Protected = ({ Component }) => {
  const navigate = useNavigate();
  const token = getAccessToken();
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const verifyAdminRole = async () => {
      try {
        const user = await getUser();
        // Admin users may not have role returned; reject USER, GUEST, BUSINESS_OWNER, BUSINESS_MEMBER
        const nonAdminRoles = ["USER", "GUEST", "BUSINESS_OWNER", "BUSINESS_MEMBER"];
        const isNonAdmin = nonAdminRoles.includes(user?.role);
        if (isNonAdmin) {
          clearLocalStorage();
          navigate("/login");
          return;
        }
        setIsAuthorized(true);
      } catch {
        clearLocalStorage();
        navigate("/login");
      }
    };

    verifyAdminRole();
  }, [token, navigate]);

  if (!token || isAuthorized === false) {
    return null;
  }

  if (isAuthorized !== true) {
    return null; // Loading while verifying role
  }

  return <>{Component}</>;
};

export default Protected;
